var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "addAffectedComponentModal",
        size: "lg",
        "hide-header-close": "",
        title: _vm.title,
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.composeObject()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.okButton))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("b-input-group-form-select", {
                attrs: {
                  required: "true",
                  label: _vm.$t("message.identifier_type"),
                  options: _vm.identityTypes,
                },
                model: {
                  value: _vm.affectedComponent.identityType,
                  callback: function ($$v) {
                    _vm.$set(_vm.affectedComponent, "identityType", $$v)
                  },
                  expression: "affectedComponent.identityType",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("b-input-group-form-input", {
                attrs: {
                  "input-group-size": "mb-3",
                  type: "text",
                  lazy: "true",
                  required: "true",
                  feedback: "true",
                  autofocus: "false",
                  label: _vm.$t("message.identifier"),
                  tooltip: this.$t("message.component_identifier_desc"),
                  "feedback-text": _vm.$t(
                    "message.required_component_identifier"
                  ),
                },
                model: {
                  value: _vm.affectedComponent.identity,
                  callback: function ($$v) {
                    _vm.$set(_vm.affectedComponent, "identity", $$v)
                  },
                  expression: "affectedComponent.identity",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("b-input-group-form-select", {
                attrs: {
                  required: "true",
                  label: _vm.$t("message.version_type"),
                  options: _vm.versionTypes,
                },
                model: {
                  value: _vm.affectedComponent.versionType,
                  callback: function ($$v) {
                    _vm.$set(_vm.affectedComponent, "versionType", $$v)
                  },
                  expression: "affectedComponent.versionType",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.affectedComponent.versionType === "RANGE"
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("b-input-group-form-select", {
                    attrs: { required: "false", options: _vm.startRangeTypes },
                    model: {
                      value: _vm.rangeBeginSyntax,
                      callback: function ($$v) {
                        _vm.rangeBeginSyntax = $$v
                      },
                      expression: "rangeBeginSyntax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                    },
                    model: {
                      value: _vm.tempVersionStartRange,
                      callback: function ($$v) {
                        _vm.tempVersionStartRange = $$v
                      },
                      expression: "tempVersionStartRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("b-input-group-form-select", {
                    attrs: { required: "false", options: _vm.endRangeTypes },
                    model: {
                      value: _vm.rangeEndSyntax,
                      callback: function ($$v) {
                        _vm.rangeEndSyntax = $$v
                      },
                      expression: "rangeEndSyntax",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                    },
                    model: {
                      value: _vm.tempVersionEndRange,
                      callback: function ($$v) {
                        _vm.tempVersionEndRange = $$v
                      },
                      expression: "tempVersionEndRange",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }